import classes from "./Diavouleusi.module.css";
import HeaderImage from "../assets/images/talk.png";
import { useEffect, useState } from "react";
import file from "../assets/icons/file.svg";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Diavouleusi = (props) => {
  const { id } = props.match.params;
  const { userDetails } = props.location.state || {};
  const [selectedSection, setSelectedSection] = useState("purpose");
  const [questionnaireAnswers, setQuestionnaireAnswers] = useState([]);
  const [refreshComponent, setRefreshComponent] = useState(false);

  useEffect(() => {
    console.log("TEST: userDetails:", userDetails);
  }, [questionnaireAnswers.length]);

  const renderAnswers = (type, answers, questionId) => {
    switch (type) {
      case "select":
        // console.log("TEST: select:", setQuestionnaireAnswers[questionId]);
        return (
          <div style={{ position: "relative", width: "120px", height: "50px" }}>
            <img
              style={{
                position: "absolute",
                right: "8px",
                top: "20px",
                width: "20px",
                height: "20px",
                cursor: "pointer",
                zIndex: "10",
              }}
              src="https://www.svgrepo.com/show/486227/down-arrow-backup-2.svg"
            />

            <select
              className={`${classes["select-base"]} `}
              name="select-radio"
              onChange={(event) => {
                const tempAnswers = questionnaireAnswers;
                tempAnswers[questionId] = event.target.value;
                setQuestionnaireAnswers(tempAnswers);
                setRefreshComponent(!refreshComponent);
              }}
            >
              <option value=""></option>
              {answers?.map((answer, id) => {
                return (
                  <option
                    key={`question_${questionId}-answer_${id}`}
                    value={answer}
                  >
                    {answer}
                  </option>
                );
              })}
            </select>
          </div>
        );

      case "checkbox":
        return answers?.map((answer, id) => {
          return (
            <div
              key={`question_${questionId}-answer_${id}`}
              className={`${classes.answer} ${
                questionnaireAnswers[questionId]?.includes(answer)
                  ? classes["answer-selected"]
                  : null
              }`}
              onClick={() => {
                const tempAnswers = questionnaireAnswers;
                if (tempAnswers[questionId] === undefined) {
                  tempAnswers[questionId] = [answer];
                } else {
                  if (tempAnswers[questionId].includes(answer)) {
                    tempAnswers[questionId] = tempAnswers[questionId].filter(
                      (answerItem) => answerItem !== answer
                    );
                  } else {
                    tempAnswers[questionId].push(answer);
                  }
                }
                setQuestionnaireAnswers(tempAnswers);
                setRefreshComponent(!refreshComponent);
              }}
            >
              {answer}
            </div>
          );
        });
      case "text":
        return (
          <textarea
            className={`${classes.text}`}
            rows="8"
            cols="60"
            onChange={(event) => {
              const tempAnswers = questionnaireAnswers;
              tempAnswers[questionId] = event.target.value;
              setQuestionnaireAnswers(tempAnswers);
              setRefreshComponent(!refreshComponent);
            }}
          />
        );
      case "radio":
        return answers?.map((answer, id) => {
          return (
            <div
              key={`question_${questionId}-answer_${id}`}
              className={`${classes.answer} ${
                questionnaireAnswers[questionId]?.includes(answer)
                  ? classes["answer-selected"]
                  : null
              }`}
              onClick={() => {
                const tempAnswers = questionnaireAnswers;
                tempAnswers[questionId] = answer;
                setQuestionnaireAnswers(tempAnswers);
                setRefreshComponent(!refreshComponent);
              }}
            >
              {answer}
            </div>
          );
        });
      default:
        return <p>test </p>;
        break;
    }
  };

  const renderContent = () => {
    switch (selectedSection) {
      case "purpose":
        return userDetails.description;
      case "questionnaire":
        return userDetails.questions?.map((question) => {
          return (
            <div key={`question_${question.id}`}>
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  letterSpacing: "1px",
                }}
              >
                {question.title}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                }}
              >
                {renderAnswers(question.type, question.answers, question.id)}
              </div>
            </div>
          );
        });
      case "files":
        return (
          <div className={classes[`file-item`]}>
            <div className={classes[`file-name`]}>
              <img src={file} alt="file icon" width={40} />
              <p>Αρχείο Διαβούλευσης</p>
            </div>
            <div>
              <a
                className={`${classes["button-base"]} ${classes["download-button"]}`}
                href={userDetails.filename}
                target="_blank"
              >
                Προβολή
              </a>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`${classes.container}`}>
      <div style={{ position: "relative" }}>
        <div className={`${classes.headerImageWrapper}`}>
          <img
            src={HeaderImage}
            alt="Diavouleusi"
            className={`${classes.headerImage}`}
          />
        </div>
        <h3 className={`${classes.headerTitle}`}>Πληροφορίες Διαβούλευσης</h3>
      </div>
      <div className={`${classes.section}`}>
        <div className={`${classes.sectionContent}`}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <div style={{ width: "calc(100% - 370px)" }}></div>
            <p
              style={{
                textAlign: "center",
                color: "#ba8e8c",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              {userDetails?.title}{" "}
            </p>
            <Link
              style={{
                color: "#E5BAB8",
                fontWeight: "600",
                marginLeft: "auto",
              }}
              to="/diavouleuseis"
            >
              Επιστροφή
            </Link>
          </div>
          <div className={`${classes.tabContainer}`}>
            <div
              className={`${classes.tabHeader} ${
                selectedSection === "purpose" && classes["tabHeader-selected"]
              }`}
              onClick={() => setSelectedSection("purpose")}
            >
              Περιγραφή
            </div>
            <div
              className={`${classes.tabHeader} ${
                selectedSection === "questionnaire" &&
                classes["tabHeader-selected"]
              }`}
              onClick={() => setSelectedSection("questionnaire")}
            >
              Ερωτηματολόγιο
            </div>
            <div
              className={`${classes.tabHeader} ${
                selectedSection === "files" && classes["tabHeader-selected"]
              }`}
              onClick={() => setSelectedSection("files")}
            >
              Αρχεία
            </div>
          </div>
          {renderContent()}
          {selectedSection === "questionnaire" && (
            <button
              className={`${classes["button-base"]} ${classes["submit-button"]}`}
            >
              Υποβολή
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
export default Diavouleusi;
